import React, { useEffect, useState } from 'react';
import { Accordion, Col, Container, Form, Button, Row, Table } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader";
import RelatedDataDialog from '../../../components/v2/RelatedDataDialog';
import DescribeAnalyzeDialog from '../../../components/v2/DescribeAnalyzeDialog';

import FORM_QUESTIONS from '../../../step2_questions.json';

const FAST_URL = process.env.REACT_APP_DS_API_URL

const initialAnalysisData = {
    toolDescription: "",
    coursesAssessed: "",
    brightspaceAutomation: "",
    hypotheticalAnalysis: "",
}

function EditButton(props) {
    return (
        <>
        {props.completed
            ?
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
                <FontAwesomeIcon icon={faCheck} inverse
                    id="icon"
                    onClick={props.onClick}
                    />
            </Button>
            :
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
            </Button>

        }
        </>
    )
}

function ViewButton(props) {
    return (
        <Button
            onClick={props.onClick}
            variant="link"
            className="w-50"
            size="md"
            id={'program-' + props.programId + '_slo-' + props.sloId}
            >
            View
        </Button>
    )
}

function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}
const STEP = 2
export default function AssessmentStep2(props) {
    // Used for Related Data Dialog
    const [programId, setProgramId] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const [programDataCache, setProgramDataCache] = useState({})

    // Used for Describe Analyze Dialog 
    const [selectedProgram, setSelectedProgram] = useState()
    const [selectedLearningOutcome, setSelectedLearningOutcome] = useState()
    const [analysisData, setAnalysisData] = useState(initialAnalysisData)
    const [analysisStore, setAnalysisStore] = useState({})
    const [showEditModal, setShowEditModal] = useState(false)

    const prefix = 'program-'

    useEffect(() => {
        if (programId && !(programId in programDataCache)) {
            let url = FAST_URL + "/program-data?programId=" + programId + "&reviewYear=2019-2020&reviewYear=2020-2021&reviewYear=2021-2022"
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let tempCache = {...programDataCache}
                tempCache[programId] = data
                setProgramDataCache(tempCache)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [programId])

    useEffect(() => {
        if (selectedLearningOutcome && (selectedLearningOutcome.sloId in analysisStore)) {
            setAnalysisData({...analysisStore[selectedLearningOutcome.sloId]})
        } else {
            setAnalysisData({...initialAnalysisData})
        }
    }, [analysisStore])

    useEffect(() => {
        if (selectedProgram && (selectedProgram.programId in props.sloAnalysisStore)) {
            setAnalysisStore({...props.sloAnalysisStore[selectedProgram.programId]})
        } else {
            setAnalysisStore({})
            setAnalysisData({...initialAnalysisData})
        }
    }, [selectedProgram])

    const handleOpenViewDialog = (event) => {
        let tokens = event.target.id.split('_')
        let programId = tokens[0].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)

        setProgramId(programId)
        setSelectedProgram(program)

        setShowModal(true)
    }

    const handleClose = () => setShowModal(false)
    const handleSave = () => setShowModal(false)

    const handleOpenEditDialog = (event) => {
        let id = event.target.id
        let tokens = event.target.id.split('_')
        if (id === 'edit' || id === 'icon') {
            tokens = event.target.parentElement.id.split('_')
        }
        let programId = tokens[0].split('-')[1]
        let sloId = tokens[1].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)
        
        setSelectedProgram(program)

        // Update which learning outcome the edit dialog was opened for.
        let slo = props.learningOutcomes[programId].find(lo => lo.sloId == sloId)
        setSelectedLearningOutcome({...slo})
        setAnalysisData({...analysisStore[sloId]})

        setShowEditModal(true)
    }

    const handleLearningOutcomeChanged = (event) => {
        let tmpLearningOutcome = selectedLearningOutcome ? selectedLearningOutcome : props.selectedLearningOutcome
        let previousSloId = tmpLearningOutcome.sloId
        let nextSloId = event.target.value
        let tmpSelectedProgram = selectedProgram ? selectedProgram : props.selectedProgram
        
        let slo = props.learningOutcomes[tmpSelectedProgram.programId].find(lo => lo.sloId == nextSloId)
        setSelectedLearningOutcome(slo)

        // Save the previous analysis data
        let dirtyAnalysisStore = {...analysisStore}
        dirtyAnalysisStore[previousSloId] = {...analysisData}
        setAnalysisStore({...dirtyAnalysisStore})

        // Show the next analysis data
        if (nextSloId in analysisStore) {
            setAnalysisData({...analysisStore[nextSloId]})
        } else {
            // No analysis exists using nextSloId, use blank fields
            setAnalysisData({...initialAnalysisData})
        }
    }

    const handleCancelEditDialog = () => setShowEditModal(false)
    const handleCloseEditDialog = () => {
        let sloId = selectedLearningOutcome.sloId
        let dirtyAnalysisStore = {...analysisStore}
        dirtyAnalysisStore[sloId] = {...analysisData}
        setAnalysisStore({...dirtyAnalysisStore})
        
        let data = {
            department: props.department,
            program: selectedProgram,
            learningOutcome: props.selectedLearningOutcome,
            sloQuestion: props.sloQuestion,
            sloAnalysisStore: {...dirtyAnalysisStore},
        }

        // Notify parent that we are saving the analysis store
        props.handleStep2DialogSave(data)

        // Hide Modal
        setShowEditModal(false)
    }

    const isLearningOutcomeDataComplete = (programId, sloId) => {
        let result = true
        if (programId in props.sloAnalysisStore && 
            sloId in props.sloAnalysisStore[programId]) {
            let textToolDescription = props.sloAnalysisStore[programId][sloId].toolDescription
            let toolDescriptionRequired = FORM_QUESTIONS["toolDescription"].required
            if (toolDescriptionRequired && 
                (!textToolDescription || textToolDescription.trim().length == 0)) {
                result = false
            }
            let textCoursesAssessed = props.sloAnalysisStore[programId][sloId].coursesAssessed
            let coursesAssessedRequired = FORM_QUESTIONS["coursesAssessed"].required
            if (coursesAssessedRequired && 
                (!textCoursesAssessed || textCoursesAssessed.trim().length == 0)) {
                result = false
            }
            let textBrightspaceAutomation = props.sloAnalysisStore[programId][sloId].brightspaceAutomation
            let brightspaceAutomationRequired = FORM_QUESTIONS["brightspaceAutomation"].required
            if (brightspaceAutomationRequired && 
                (!textBrightspaceAutomation || textBrightspaceAutomation.trim().length == 0)) {
                result = false
            }
            let textHypotheticalAnalysis = props.sloAnalysisStore[programId][sloId].hypotheticalAnalysis
            let hypotheticalAnalysisRequired = FORM_QUESTIONS["hypotheticalAnalysis"].required
            if (hypotheticalAnalysisRequired && 
                (!textHypotheticalAnalysis || textHypotheticalAnalysis.trim().length == 0)) {
                result = false
            }
        } else {
            if (!(programId in props.sloAnalysisStore)) {
                result = false
            } else if (!(sloId in props.sloAnalysisStore[programId])) {
                result = false
            }
        }
        return result
    }

    const isStepComplete = (programId) => {
        // Prevent edit of step if next step is complete
        if (props.step3CompletionData[programId] &&
            props.step3CompletionData[programId].completed) {
            return false
        }

        // Step cannot be completed if previous steps were not.
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return false
        }

        if (!props.sloAnalysisStore) {
            console.log('what analysis store?')
            return false
        }

        let result = true
        availableLearningOutcomes[programId].map((slo) => {
            result = isLearningOutcomeDataComplete(programId, slo.sloId)
        })
        return result
    }
    
    React.useEffect(() => {
        window.scrollTo(0,0)
    }, [])

    let allPrograms = props.department.submittedPrograms
    let filteredPrograms = []
    
    if (filteredPrograms.length == 0) {
        filteredPrograms = allPrograms.filter(function(obj) {
            return (props.activePrograms[obj.programId] == 'yes')
        })
    }
    
    let themeName = props.theme.name
    let availableLearningOutcomes = {}

    props.department.submittedPrograms.map(program => {
        let programMappedSlos = props.mappedSlos[program.programId]
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }
        
        if (program.programId in props.learningOutcomes) {
            props.learningOutcomes[program.programId].map(slo => {
                if (slo.sloId in programMappedSlos) {
                    let mappedSlo = programMappedSlos[slo.sloId]
                    if (mappedSlo.firstTheme === themeName && mappedSlo.firstThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.secondTheme === themeName && mappedSlo.secondThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.thirdTheme === themeName && mappedSlo.thirdThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    }
                }
            })
        }
        
    })
    
    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step2CompletionData && props.step2CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />

            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    Use the ‘Edit’ buttons below to describe the assessment tool 
                    that will be used to assess each of the learning outcomes. If 
                    multiple outcomes will be assessed using the same tool, 
                    information can be copied and pasted as needed. Please review 
                    background information about Designing/Adapting Assessment 
                    Tools before continuing: <a href="https://rise.articulate.com/share/8PlCRlz2thD7iLcdfRdjiQfYfS08LBWq" target="_blank" rel="noopener noreferrer">View</a>
                </div>
                <DepartmentHeader department={props.department} />

                <div className="mx-auto">
                    <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                    {
                        filteredPrograms?.map((program,key) =>
                            <Accordion.Item eventKey={prefix + program.programId} key={program.programId}>
                                <Accordion.Header>
                                    {program.name} {(program.programId in props.step2CompletionData && props.step2CompletionData[program.programId].completed) ? ' - Completed' : ''}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Table key={key}>
                                        <thead>
                                            <tr>
                                                <th>Learning Outcome</th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                availableLearningOutcomes[program.programId].map((slo,index) => {
                                                    return (
                                                    <tr key={index}>
                                                        <td width="80%">
                                                            { slo.text }
                                                        </td>
                                                        <td>
                                                        </td>
                                                        <td width="10%">
                                                            <EditButton
                                                                onClick={handleOpenEditDialog}
                                                                programId={program.programId}
                                                                sloId={slo.sloId}
                                                                disabled={!(program.programId in props.step1DataStore && slo.sloId in props.step1DataStore[program.programId])}
                                                                completed={isLearningOutcomeDataComplete(program.programId, slo.sloId)}
                                                                />
                                                        </td>
                                                    </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                    <Container fluid>
                                        <Row>
                                            <Col 
                                                md={{span: 8, offset: 3}}
                                                lg={{span: 12, offset: 4}}
                                                >
                                                <CompletedCheckBox
                                                    onChange={props.onStepCompleted}
                                                    programId={program.programId}
                                                    completed={props.step2CompletionData[program.programId]?.completed}
                                                    defaultChecked={props.step2CompletionData[program.programId]?.completed}
                                                    ariaLabel="Step 2 is complete"
                                                    label="By checking this box you are completing Step 2 for your program area"
                                                    step="2"
                                                    disabled={!isStepComplete(program.programId)}
                                                    />
                                            </Col>
                                        </Row>
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                        )
                    }
                    </Accordion>
                </div>
            </div>
            <DescribeAnalyzeDialog
                department={props.department}
                theme={props.theme}
                selectedProgram={selectedProgram}
                selectedLearningOutcome={selectedLearningOutcome}
                learningOutcomes={availableLearningOutcomes}
                step1DataStore={props.step1DataStore}
                stepCompletionData={props.step2CompletionData}
                step1CompletionData={props.step1CompletionData}
                showModal={showEditModal}
                handleCloseDialog={handleCloseEditDialog}
                handleCancelDialog={handleCancelEditDialog}
                handleLearningOutcomeChanged={handleLearningOutcomeChanged}
                analysisData={analysisData}
                onToolDescriptionChanged={(e) => setAnalysisData(prevAnalysisData => ({...prevAnalysisData, toolDescription: e.target.value}))}
                onCoursesAssessedChanged={(e) => setAnalysisData(prevAnalysisData => ({...prevAnalysisData, coursesAssessed: e.target.value}))}
                onBrightspaceAutomationChanged={(e) => setAnalysisData(prevAnalysisData => ({...prevAnalysisData, brightspaceAutomation: e.target.value}))}
                onHypotheticalAnalysisChanged={(e) => setAnalysisData(prevAnalysisData => ({...prevAnalysisData, hypotheticalAnalysis: e.target.value}))}
                />
            <RelatedDataDialog
                department={props.department}
                programId={programId}
                selectedProgram={selectedProgram}
                programs={filteredPrograms}
                programDataCache={programDataCache}
                showModal={showModal}
                onProgramChanged={(e) => setProgramId(e.target.value)}
                handleSaveDialog={handleSave}
                handleCloseDialog={handleClose}
                />
        </React.Fragment>
    )
}
